module.exports = __webpack_public_path__ + "static/media/BR.437f84dc.png";